import {HStack, Icon, Image, VStack, Text, Box, Flex, Button} from "@chakra-ui/react";
import Logo from '@/assets/images/cyberjob_dialogflow_logo.svg';
import {HiOutlineCircleStack, HiOutlineClipboardDocumentList, HiOutlinePlus, HiChatBubbleLeft, HiOutlineGlobeAlt, HiOutlineCog6Tooth, HiOutlineUserCircle, HiOutlineUsers, HiOutlineCpuChip, HiOutlineBriefcase, HiOutlineBeaker} from "react-icons/hi2";
import MenuItem from "@/components/ui/menu/MenuItem";
import LanguageSelector from "@/components/ui/menu/LanguageSelector";
import TobBar from '@/components/layout/TopBar';
import {Outlet} from "react-router-dom";
import {IoGitNetworkOutline} from "react-icons/io5";
import {useAuth} from "@/auth/AuthContext";


const Layout = () => {
    const { currentUser } = useAuth();

    return (
        <HStack w={'full'} minH={'100vh'} gap={0} alignItems={'flex-start'}>
            <Box minW={260}>
                <VStack
                    bg="bg.secondary"
                    h={'100vh'}
                    pos={'fixed'}
                    w={260}
                    alignItems={'flex-start'}
                    py={6}
                    borderRightWidth={'1px'}
                    borderRightColor={'border.primary'}>
                    <Image src={Logo} w={'70%'} ml={4}/>
                    <VStack mt={10} w={'100%'} h={'full'} justifyContent={'space-between'}>
                        <VStack w={'100%'}>
                            <MenuItem url={'/models'} label={'Models'} icon={<HiOutlineCpuChip/>}/>
                            <MenuItem url={'/scenarios'} label={'Scenarios'} icon={<HiOutlineCircleStack/>}/>
                            <MenuItem url={'/chat'} label={'Chat'} icon={<HiChatBubbleLeft/>}/>
                            <MenuItem url={'/endpoints'} label={'Endpoints'} icon={<HiOutlineGlobeAlt/>}/>
                            <MenuItem url={'/workers'} label={'Workers'} icon={<IoGitNetworkOutline/>}/>
                            <MenuItem url={'/settings'} label={'Settings'} icon={<HiOutlineCog6Tooth/>}/>
                            <MenuItem url={'/account'} label={'Account'} icon={<HiOutlineUserCircle/>}/>
                            {currentUser?.role === 'Admin' && (
                                <MenuItem url={'/users'} label={'Users'} icon={<HiOutlineUsers/>}/>
                            )}
                            {currentUser?.role === 'Admin' && (
                                <MenuItem url={'/clients'} label={'Clients'} icon={<HiOutlineBriefcase/>}/>
                            )}
                            {currentUser?.role === 'Admin' && (
                                <MenuItem url={'/recruitment-tests'} label={'Recruitment Tests'} icon={<HiOutlineBeaker/>}/>
                            )}
                        </VStack>
                        <VStack w={'100%'} px={4} rowGap={4}>
                            <LanguageSelector/>
                        </VStack>
                    </VStack>
                </VStack>
            </Box>
            <VStack alignItems={'flex-start'} w={'full'} minW={0} minH={'100vh'} gap={0}>
                <TobBar/>
                <VStack w={'100%'} minW={0} maxW={'full'} py={6} px={6}>
                    <Outlet />
                </VStack>
            </VStack>
        </HStack>
    )
}

export default Layout;